export enum RewardStatus {
  RS_UNSET = 'RS_UNSET', // Do not use, needed because of proto3 limitations
  RS_ACTIVATED = 'RS_ACTIVATED',
  RS_REDEEMED = 'RS_REDEEMED',
}
